export const styles = {
  header: { padding: '0 50px' },
  tableWrapper: {
    backgroundColor: '#fff',
    '& .SearchAndFilters': {
      marginLeft: '50px',
    },
  },
  createButton: { marginLeft: 50, width: 180 },
  actionButtons: {
    display: 'flex',
  },
  pagination: {
    padding: '0 50px',
  },
}
